import './scripts/common';

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

import {onFind} from "@elements/init-modules-in-scope";

import * as overlay from './scripts/overlay'
overlay.init();

import * as ajaxForm from '@elements/ajax-form';
ajaxForm.init();

import * as ajaxFormExtend from './scripts/ajax-form-extend';
ajaxFormExtend.init();

import * as formValidation from '@elements/form-validation';
formValidation.init();

import * as fileInput from '@elements/file-input';
fileInput.init();

import * as dropzone from './scripts/dropzone';
dropzone.init();

import * as checkboxList from './scripts/checkbox-list';
checkboxList.init();

import * as accountCartCopy from './scripts/account-cart-copy';
accountCartCopy.init();

import * as sortableReactSelect from './scripts/sortable-react-select';
sortableReactSelect.init();

import * as repeatPasswordFv from './scripts/repeat-password-fv';
repeatPasswordFv.init();

import * as multiCollapse from './scripts/multi-collapse';
multiCollapse.init();

import * as pricelistGenerator from './scripts/pricelist-generator';
pricelistGenerator.init();

import * as accountItems from './scripts/account-items';
accountItems.init();

import * as datepicker from "@elements/datepicker";
datepicker.init();

import * as datepickerRange from "@elements/datepicker-range";
datepickerRange.init();

import * as affixForm from './scripts/affix-form';
affixForm.init({mediaQuery: '(min-width: 768px)'});

import * as asyncAppend from "./scripts/async-append";
asyncAppend.init();

import * as tablesort from "./scripts/tablesort";
tablesort.init();

import * as fileUpload from "./scripts/file-upload";
fileUpload.init();

import * as checkPricelist from "./scripts/check-pricelist";
checkPricelist.init();

import * as dynamicModal from './scripts/dynamic-modal'
dynamicModal.init();

import * as productItem from './scripts/product-item'
productItem.init();

import * as inputReset from './scripts/input-reset'
inputReset.init();

import * as regexSelect from './scripts/regex-select'
regexSelect.init();

import * as tableLink from './scripts/table-link'
tableLink.init();

import * as postalCodeMapping from './scripts/postal-code-mapping'
postalCodeMapping.init();

import * as orderArchive from './scripts/order-archive/index'
orderArchive.init();

import * as offers from './scripts/offers/index'
offers.init();